<template>
  <div
    class="collection-grid grid"
    :class="[template]"
  >
    <div
      v-if="template != 'sawmills'"
      class="col xs6 l3 expand-right-l collection-filter__wrapper"
    >
      <overlay
        v-if="isMobile"
        key="filters"
        block-class="filters"
        direction="right"
        namespace="filters"
        type="drawer"
      >
        <template #body>
          <main-collection-filter
            :filters="filters"
            @update-filters="updateFilters"
          />
        </template>
      </overlay>

      <main-collection-filter
        v-else
        :filters="filters"
        @update-filters="updateFilters"
      />
    </div>
    <div
      :class="gridSize"
    >
      <div
        class="collection-grid__products-header--mobile col xs-span"
      >
        <div class="collection-grid__filters">
          <div class="collection-grid__filter">
            <btn
              :label="$string('collection.filter.label')"
              modifiers="secondary reversed"
              type="button"
              show-icon
              @click="openFilters"
            >
              <template #icon>
                <icon-filter />
              </template>
            </btn>
          </div>
          <div
            class="
                collection-grid__products-sort
                mb-2xl0-desktop
                text-body-s-regular
                text-body-m-regular-desktop
                col xs6 l9
              "
          >
            <div class="form-group text-other-button-s">
              <select
                v-model="sort"
                class="collection-grid__select border py-2 px-3"
                @change="updateSort"
              >
                <option
                  v-for="(option, index) of sortOptions"
                  :key="`sort-${index}`"
                  :value="option"
                  v-text="$string(`collection.sort.${option.toLowerCase()}`)"
                />
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="collection-grid__products-header col xs-span my-l">
        <div
          class="collection-grid__count"
        >
          <p
            v-if="currentResultCount && totalResultsCount"
            v-text="productCount"
          />
        </div>
        <div
          class="
              collection-grid__products-sort
              mb-2xl0-desktop
              text-body-s-regular
              text-body-m-regular-desktop
              col xs6 l9
            "
        >
          <div class="form-group">
            <p
              class="text-heading-m"
              v-text="$string('collection.sort.label')"
            />
            <select
              v-model="sort"
              class="border py-2 px-3"
              @change="updateSort"
            >
              <option
                v-for="(option, index) of sortOptions"
                :key="`sort-${index}`"
                :value="option"
                v-text="sortLabel(option)"
              />
            </select>
          </div>
        </div>
      </div>
      <div class="collection-grid__products grid col xs-span">
        <div
          v-for="(product, index) of productList"
          :key="product.id"
          class="col"
          :class="index === 4 && banner ? bannerClass : gridClass "
        >
          <product-card-sawmill
            v-if="template === 'sawmills' && index !== 4 || template === 'sawmills' && !banner"
            :product="product"
            :labels="labels"
            @click="captureClickedProduct(product)"
            @product-card-loaded="captureLoadedPrdouct"
          />

          <product-card
            v-else-if="index !== 4 || !banner"
            :product="product"
            :labels="labels"
            :loading=" loading"
            @display-options="getProductVariants(product)"
            @click="captureClickedProduct(product)"
            @product-card-loaded="captureLoadedPrdouct"
          />

          <div
            v-if="banner && index === 4"
            class="main-collection__banner"
            v-html="banner"
          />
        </div>
        <div class="collection-grid__load-more grid col xs-span mt-3xl">
          <btn
            v-if="searchMore"
            class="collection-grid__load-btn col xs4 l5-8"
            :label="$string('collection.load_more')"
            modifiers="secondary"
            @click="$emit('load-more-products')"
          >
            <icon-arrow-right />
          </btn>
        </div>
      </div>
    </div>
    <overlay
      v-if="productDrawer"
      key="details"
      block-class="product-drawer"
      direction="left"
      namespace="details"
      type="drawer"
    >
      <template #body>
        <responsive-image
          :image="productDrawer.media[0].image"
          min-max="600-1000"
          ratio="4:3"
        />
        <div class="product-drawer__content">
          <h2
            class="
              main-product__title
              text-heading-xl
            "
            v-text="productDrawer.title"
          />
          <div class="main-product__meta">
            <p
              class="main-product__sku text-body-xs-regular"
              v-text="selectedVariant.sku"
            />

            <product-rating
              :sku="selectedVariant.sku"
            />
          </div>
          <div
            class="product-drawer__description text-body-s-regular"
            v-html="productDrawer.description"
          />
          <div
            v-if="drawerModel"
            class="product-drawer__model"
          >
            <span
              class="text-body-xs-regular"
              v-text="$string('collection.compatible_with')"
            />
            <span
              class="text-heading-m"
              v-text="drawerModel"
            />
          </div>
          <product-prices
            class-price="text-heading-xl"
            :available="selectedVariant.available"
            :compare-at-price="selectedVariant.compareAtPrice?.amount"
            :price="selectedVariant.price?.amount"
            :varies="selectedVariant.price?.varies"
          />
          <product-form
            :product="productDrawer"
            :variant="selectedVariant"
            @update-variant="updateVariant"
          />
        </div>
      </template>
    </overlay>
  </div>
</template>

<script>

import Btn from '~global/btn/btn'
import ProductCard from '~async/product-card/product-card'
import ProductCardSawmill from '~async/product-card-sawmill/product-card-sawmill'
import ProductForm from '~async/product-form/product-form'
import ProductPrices from '~global/product-prices/product-prices'
import ProductRating from '~async/product-rating/product-rating'
import MainCollectionFilter from '~async/main-collection/main-collection-filter'
import ResponsiveImage from '~global/images/responsive-image'
import IconFilter from '~icons/general/filter.svg'
import IconArrowRight from '~icons/directional-navigation/arrow/right.svg'
import Overlay from '~global/overlay/overlay'
import productQuery from '~/graphql/queries/product.gql'

import { formatProduct, formatUrl } from '~/helpers/format'

import { mapActions, mapState } from 'vuex'

import {
  KlevuSearchSorting,
// eslint-disable-next-line import/no-unresolved
} from '@klevu/core'

/**
 * Vue: Collection grid (collection-grid)
 * -----------------------------------------------------------------------------
 * Collection grid for Klevu.
 *
 */
export default {
  name: 'CollectionGrid',
  components: {
    Btn,
    IconFilter,
    IconArrowRight,
    MainCollectionFilter,
    Overlay,
    ProductCard,
    ProductCardSawmill,
    ProductForm,
    ProductPrices,
    ProductRating,
    ResponsiveImage,
  },
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    banner: {
      type: [Boolean, String],
      default: false,
    },
    currentResultCount: {
      type: [Boolean, Number],
      default: false,
    },
    productClickEvent: {
      type: [Boolean, Function],
      default: false,
    },
    searchMore: {
      type: Boolean,
      default: false,
    },
    totalResultsCount: {
      type: [Boolean, Number],
      default: false,
    },
    template: {
      type: String,
      default: '',
    },
    gridSize: {
      type: String,
      default: 'col xs6 l9 pr-5xl-desktop pl-2xl-desktop',
    },
    gridClass: {
      type: String,
      default: 'col xs3 l4',
    },
    labels: {
      type: Object,
      default: () => ({
        new: '',
        sale: '',
        most_popular: '',
        best_seller: '',
        freeShipping: '',
      }),
    },
    liquid: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: [Boolean],
      default: false,
    },
  },
  emits: {
    'update-filters': () => true,
    'update-search-sort': () => true,
    'load-more-products': () => true,
    'all-cards-loaded': () => true,
  },

  data() {
    return {
      productDrawer: false,
      drawerModel: false,
      selectedVariant: false,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      viewedProducts: [],
      productCardloadCount: 0,
      allCardsLoaded: false,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    productCount() {
      const text = this.$string('collection.count')

      if (!text) {
        return ''
      }

      return text.replace('{{current}}', this.currentResultCount).replace('{{total}}', this.totalResultsCount)
    },

    bannerClass() {
      if (this.template === 'sawmills') {
        return 'xs-span l12'
      }

      return 'xs-span l8'
    },
  },

  watch: {
    productDrawer() {
      if (!this.productDrawer) {
        return
      }

      this.selectedVariant = this.productDrawer.variants[0]
    },
  },

  mounted() {
    this.setSortOptions()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    captureLoadedPrdouct() {
      if (this.allCardsLoaded) {
        return
      }
 
      this.productCardloadCount += 1
    if (this.productCardloadCount >= 6 || this.productCardloadCount >= this.totalResultsCount) {
        this.allCardsLoaded = true
        this.$emit('all-cards-loaded')
      }
    },

    captureClickedProduct(product) {
      if (this.productClickEvent) {
        this.productClickEvent(product.id, product.title)

      }
    },

    updateSort() {
      this.$emit('update-search-sort', this.sort)
    },

    updateFilters(key, value) {
      this.$emit('update-filters', key, value)
    },

    openFilters() {
      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'filters',
      })
    },

    openProductDetails() {
      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'details',
      })
    },

    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_ASC', 'PRICE_DESC']
      this.sortOptions = selectedOptions
    },

    sortLabel(option) {
      const label = `collection.sort.${option.toLowerCase()}`
      return this.$string(`${label}`)
    },

    async getProductVariants(product) {
      const { country, language } = window.cnvs.store
      const savedVariant = this.liquid.products.find((item) => item.handle === product.handle)

      if (savedVariant) {
        this.productDrawer = savedVariant
        this.drawerModel = product.compatibility
        this.openProductDetails()
        return
      }

      try {
        const response = await cnvs.Query({
          query: productQuery,
          variables: {
            country,
            handle: product.handle,
            language,
          },
        })

        const formattedProduct = formatProduct(response)
        this.productDrawer = formattedProduct
        this.viewedProducts.push(formattedProduct)
        this.drawerModel = product.compatibility
        this.openProductDetails()

      } catch (error) {
        this.productDrawer = false
        window.location = formatUrl(product.url)
        cnvs.ReportError('Failed to fetch products', error)
      }
    },

    updateVariant(variant) {
      this.selectedVariant = variant
    },
  },
}
</script>

<style lang="scss">
@import './collection-grid';
</style>
